import { GraphId, NodeId } from '../../types';

/**
 * Queue envelope for evaluating a (sub)graph.
 *
 * Invariants:
 * - `dirty` contains node ids from the graph version referenced by this batch.
 * - `graphVersion`/`topologyVersion` identify the model snapshot this batch was produced from.
 */
export type GraphBatchQueryItem = {
  id: string;
  entryId: string;
  graphId: GraphId;
  graphVersion: number;
  topologyVersion: number;
  dirty: Set<NodeId>;
};

/**
 * Runtime status materialized for UI/debugging.
 */
export type GraphBatchRuntimeState = {
  status: Record<NodeId, 'pending' | 'running' | 'ok' | 'error' | 'skipped'>;
};

export type NodeEvalRequest = {
  nodeId: NodeId;
  template: unknown;
};

export enum NodeEvalStatus {
  Ok = 'ok',
  Error = 'error',
  Skipped = 'skipped',
}

export type NodeEvalResult =
  | {
      nodeId: NodeId;
      status: NodeEvalStatus.Ok;
      result: unknown;
      fingerprint: string;
    }
  | {
      nodeId: NodeId;
      status: NodeEvalStatus.Error;
      message: string;
    }
  | {
      nodeId: NodeId;
      status: NodeEvalStatus.Skipped;
    };
